var React = require('react');

function Procedures (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 224a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm368 0H272a16 16 0 0 0-16 16v144h384v-48.09A111.93 111.93 0 0 0 528 224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M136 96h126.1l27.6 55.2a16 16 0 0 0 28.6 0L368 51.83 390.1 96H512a16 16 0 0 0 0-32H409.9L382.3 8.83a16 16 0 0 0-28.6 0l-49.7 99.4-19.9-39.8a8 8 0 0 0-7.2-4.4H136a8 8 0 0 0-8 8V88a8 8 0 0 0 8 8zm120 288H64V144a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v352a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-48h512v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V384z","className":"fa-primary","key":2})]);
}

Procedures.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Procedures;

Procedures.default = Procedures;
